/**
 * @param String with words separated by spaces or underscores
 * @returns String with the first letter of each word capitalized without removing special characters
 *
 * @example
 * toCapitalized("hello world") // "Hello World"
 * toCapitalized("hello_world") // "Hello World"
 * toCapitalized("hello / world") // "Hello / World"
 */
export function toCapitalized(str: string) {
  return str
    .replace(/_/g, " ")
    .replace(
      /\w+/g,
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    );
}
